/**
 * Game Test Page (Company App Wrapper)
 *
 * @quebon/games의 GameTestPage 공통 컴포넌트를 사용.
 * API adapter 없이 mock으로 테스트. 실제 랭킹 API 연동 시 adapter 주입.
 */
import { GameTestPage as SharedGameTestPage } from '@quebon/games'

export default function GameTestPage() {
  return <SharedGameTestPage />
}
